import {Text} from '@rdcomponents/text/text';
import {Button} from 'antd';
import {PropsWithChildren} from 'react';

import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';

import * as styles from './new-upload-button.scss';

type PropsType = PropsWithChildren<{
    title: LangKeyType;
}>;

export function NewUploadButton(props: PropsType): JSX.Element {
    const {title, children} = props;

    return (
        <Button className={styles.UploadButton} type="dashed">
            <Text bolder stringKey={title} />
            {children}
        </Button>
    );
}
